import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import t from '@guestyci/localize/t.macro';

import Icon from 'components/common/Icon';

const PoweredBy = ({ white, className }) => (
  <div className={cn('powered-by', { white, [className]: className })}>
    <span className="mr-2">{`${t('Powered by')}:`}</span>
    <Icon icon={white ? 'guesty-logo-white' : 'guesty-logo-gray'} />
  </div>
);
PoweredBy.defaultProps = {
  white: true,
};
PoweredBy.propTypes = {
  white: PropTypes.bool,
};

export default ({ isVisible, ...rest }) =>
  isVisible ? <PoweredBy {...rest} /> : null;
